// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2OXQz","col":"CardReaderDesc_col__12_8u","label":"CardReaderDesc_label__3FD6M"};